import React from 'react';

import Modal from '../../common/modal/Modal';

const SumbmitModal = ({
  icon, 
  text, 
  title, 
  btnText, 
  handleModal, 
  open, 
  validated = true, 
  width
}) => {
  const onCloseHandler = () => {
    handleModal(false);
  }

  return (
    <div className={`submit-modal ${open ? 'visible' : 'hidden'}`} >
      <Modal
        width={width}
        onLabelClosed={true} 
        visible={open} 
        onToggle={handleModal} 
        className={open ? 'submit-modal-main' : ''} 
        onLabelTextClosed=''>
        <div className="submit-modal-main__info">
          <div className="submit-modal-main__info-container">
            { icon && <img src={icon} alt='icon'/> }
            <h1>{title}</h1>
            <div className="submit-modal-main__info-content">
              <div>{text}</div>
            </div>
          </div>
          <div className="submit-modal-main__info-actions">
            <div className="submit-modal-main__info-button">
              <button 
                className="submit-modal-main__info-button--base" 
                disabled={false}
                onClick={onCloseHandler}>
                  {btnText}
                </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SumbmitModal;